import { render } from "./OnetoFiveImageDiv.vue?vue&type=template&id=4f2a4b6c&scoped=true&ts=true"
import script from "./OnetoFiveImageDiv.vue?vue&type=script&lang=ts"
export * from "./OnetoFiveImageDiv.vue?vue&type=script&lang=ts"

import "./OnetoFiveImageDiv.vue?vue&type=style&index=0&id=4f2a4b6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2a4b6c"]])

export default __exports__